<script setup lang="ts">
import {defineProps} from 'vue'
const props = defineProps({
  activities: {type: Array, default: ()=> []}
})
</script>

<template>
  <div class="uk-padding uk-padding-remove-horizontal uk-position-relative impx-sections-spa uk-background-fixed uk-background-center-center uk-height-1-1">
    <div class="impx-overlay dark"></div>
    <div class="uk-container">

      <div class="uk-flex-center" data-uk-grid>
        <div class="uk-width-3-5@xl uk-width-3-5@l uk-width-1-1@m uk-width-1-1@s">
          <!-- intro -->
          <div class="impx-intro uk-text-center uk-position-relative uk-position-z-index">
            <h2 class="impx-text-white uk-margin-remove-bottom">Nos espace de loisir</h2>
          </div>
          <!-- intro end -->
        </div>
      </div>

      <!-- services list -->
      <ul class="uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1@s data-uk-grid impx-spa-services uk-position-relative uk-position-z-index uk-grid-match uk-margin-bottom" data-uk-grid>
        <li v-for="(item,index) in props.activities" :key="index"><!-- service item #1 -->
          <div class="impx-spa-service">
            <div class="uk-grid uk-grid-collapse">
              <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s uk-position-relative">
                <div class="uk-height-1-1 uk-cover-container">
                  <canvas width="290" height="220"></canvas>
                  <img :src="'./images/heading/hobbies-4.jpg'" alt="resort" class="" data-uk-cover>
                </div>
              </div>
              <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s">
                <div class="impx-spa-content">
                  <span class="uk-label uk-label-success small">À partir {{item.price}}</span>
                  <h4 class="uk-margin-remove">{{item?.title}}</h4>
                  <p>{{item?.subtitle}}</p>
                  <ul class="uk-list">
                    <li v-for="(itemFacilitie,index) in item.facilities" :key="index"><i :class="['fa' , itemFacilitie?.icon]"></i> {{itemFacilitie?.title}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li><!-- service item #1 end -->
      </ul>
      <!-- services items end -->
    </div>
  </div>

</template>

<style scoped>

</style>